import { render, staticRenderFns } from "./CrewDetails.vue?vue&type=template&id=74e7eb93&scoped=true&"
import script from "./CrewDetails.vue?vue&type=script&lang=js&"
export * from "./CrewDetails.vue?vue&type=script&lang=js&"
import style0 from "./CrewDetails.vue?vue&type=style&index=0&id=74e7eb93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e7eb93",
  null
  
)

export default component.exports